import { useEffect, useRef, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { Button } from "@/components/design/Button";
import { ServiceCard } from "@/pages/save/service/ServiceCard";
import { MOCK_IMPORT_SERVICES } from "./project-mock-data";

// Die Anbindungen des Projekts, hinter demselben Knopf wie im Profil
// (components/save/ServiceMenu). Gleiche Karten (ServiceCard), gleiche
// Zweispaltigkeit, gleiche Gruppenüberschrift, gleiches Öffnen und Schliessen.
//
// Die erste Fassung hatte eine eigene kleine Kachel in vier Spalten - dieselbe
// Sache, anders gebaut, mit Beschreibungen, die nach drei Wörtern umbrachen.
// Wer im Profil gelernt hat, wie Anbindungen aussehen, soll hier nichts Neues
// lesen müssen.
//
// Prototyp-Platzhalter ohne Anbieter-Anbindung. Der Klick zeigt nur einen
// Hinweis. Verfügbarkeitskennzeichnung und Markenfarben sind offene Designfragen,
// keine beschlossene Ausnahme vom bestehenden Designsystem.

export function ProjectServiceMenu() {
  const intl = useIntl();
  const [open, setOpen] = useState(false);
  const [hint, setHint] = useState<string | null>(null);
  const wrapperRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!hint) return;
    const t = setTimeout(() => setHint(null), 2200);
    return () => clearTimeout(t);
  }, [hint]);

  return (
    <div
      ref={wrapperRef}
      className="relative inline-block"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      onKeyDown={(e) => e.key === "Escape" && setOpen(false)}
    >
      <Button
        id="project-service-menu-open"
        variant="primary"
        size="compact"
        aria-haspopup="menu"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
      >
        <FormattedMessage id="profile.page.serviceMenu" defaultMessage="Service" />
      </Button>
      {open ? (
        // Kein Abstand nach oben, damit der Zeiger nie durch tote Fläche muss -
        // sonst flackert der Aufklapper. Übernommen aus dem Profil-Menü.
        <div className="toggle-pop absolute right-0 top-full z-30 max-h-[80vh] w-[min(92vw,420px)] origin-top-right overflow-auto rounded-md bg-surface p-4 shadow-lg ring-1 ring-ink/10">
          <div className="smycles-field-label mb-2">
            <FormattedMessage id="project.service.importTitle" defaultMessage="Kontext holen" />
          </div>
          <div className="grid grid-cols-2 gap-3">
            {MOCK_IMPORT_SERVICES.map((svc) => (
              <ServiceCard
                key={svc.id}
                id={`project-service-import-${svc.id}`}
                icon={svc.icon}
                iconColor={svc.color}
                title={intl.formatMessage(svc.title)}
                desc={intl.formatMessage(svc.desc)}
                tags={intl.formatMessage({
                  id: "project.service.importTags",
                  defaultMessage: "Import · Kontext",
                })}
                onClick={() =>
                  setHint(
                    intl.formatMessage(
                      { id: "project.import.notLinked", defaultMessage: "{service} ist aktuell nicht verlinkt" },
                      { service: intl.formatMessage(svc.title) },
                    ),
                  )
                }
              />
            ))}
          </div>
          {hint ? <div id="project-service-hint" className="smycles-field-meta mt-3 text-ink">{hint}</div> : null}
        </div>
      ) : null}
    </div>
  );
}
